import styled from 'styled-components';
import { imageUrl } from '../services/helpers';
import { CARD_ASPECT, Count, StatusBadges } from '../Card/styled';
import { MAT_ASPECT, MAT_CARD_WIDTH } from './layout';

/*
 * Both boards size themselves from the board area around them (a size container), so they fit whatever space the
 * screen layout leaves, upright or sideways.
 */

export const Mat = styled.div`
  position: relative;
  container-type: inline-size;
  width: min(100cqw, 100cqh * ${MAT_ASPECT});
  aspect-ratio: ${MAT_ASPECT};
  margin: auto;
`;

export const MatPhoto = styled.div`
  position: absolute;
  inset: 0;
  background: url(${imageUrl('/gamemap.jpg')}) center / 100% 100% no-repeat;
  ${props => props.$turned && 'transform: rotate(180deg);'}
`;

export const Half = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;

  ${props => props.$opponent && `
    transform: rotate(180deg);

    /* The opponent's cards face them, but their numbers and conditions should still read the right way up for you. */
    ${Count}, ${StatusBadges} {
      rotate: 180deg;
    }
  `}
`;

export const Spot = styled.div`
  position: absolute;
  --card-w: ${MAT_CARD_WIDTH}cqw;
  pointer-events: auto;
`;

export const Table = styled.div`
  --active-w: min((100cqw - 40px) / 3.2, (100cqh - 44px) / 4.6);
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 6px;
`;

export const Side = styled.div`
  display: flex;
  flex-direction: ${props => props.$opponent ? 'column-reverse' : 'column'};
  align-items: center;
  gap: 8px;
`;

export const Front = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Active = styled.div`
  --card-w: var(--active-w);
`;

export const PrizeGrid = styled.div`
  --card-w: calc(var(--active-w) * .3);
  display: grid;
  grid-template-columns: repeat(2, var(--card-w));
  grid-auto-rows: calc(var(--card-w) / ${CARD_ASPECT});
  gap: 3px;
`;

export const Piles = styled.div`
  --card-w: calc(var(--active-w) * .48);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const BenchRow = styled.div`
  --card-w: calc(var(--active-w) * .64);
  display: flex;
  gap: 6px;
`;

export const TableDivider = styled.div`
  width: 60%;
  height: 1px;
  background: var(--line);
`;

/**
 * Where the opponent's hand is, as far as cards flying there go: just past the far edge of the board, in the middle
 * of their side, where they sit. Nothing shows; a card drawn or taken flies there and goes into their hand.
 */
export const OpponentHandEdge = styled.div`
  position: absolute;
  /* Toward the right: it pokes up into the opponent's bar, and their name starts at the left. */
  left: 76%;
  top: 0;
  width: var(--card-w, 48px);
  aspect-ratio: ${CARD_ASPECT};
  transform: translate(-50%, -70%);
  pointer-events: none;
`;

/** The Table view's place for the opponent's hand: above their side, in the middle. */
export const TableHandEdge = styled.div`
  width: calc(var(--active-w) * .45);
  aspect-ratio: ${CARD_ASPECT};
  margin-bottom: 4px;
  pointer-events: none;
`;
